import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
// import Modal from '@xpeng/react-modal';
// import Modal from './modal';
import Modal from './component';
// import '@xpeng/react-modal/build/index.css';
// import Icon from '@/component/icon';
// import { IS_WX_H5_ENV } from '@/modules/common';
// import { setScrollTop } from '@/modules/scroll';
import './index.scss';

interface PropsType {
  children: React.ReactNode;
  isOpened: Boolean;
  position?: 'top' | 'center' | 'bottom';
  isMask?: boolean;
  isLock?: boolean;
  closeOnClickOverlay?: boolean;
  zIndex?: number;
  target?: React.RefObject<HTMLElement>;
  title?: string,
  paddingBottom?: boolean;
  onHide: () => void;
  onClick?: () => any;
  closeIcon?: boolean,
  className?: string,
  useAnimate?: boolean;
  onShowed?: () => void;
}

function setScrollTop(height?: number) {
  if (height !== undefined && !Number(height)) {
    document.body.scrollTop = document.documentElement.scrollTop = height
  } else {
    return document.body.scrollTop || document.documentElement.scrollTop
  }
}

export default (props: PropsType) => {
  const {
    isOpened,
    title = '',
    onHide = () => {},
    onClick = (e: React.MouseEvent) => { },
    closeIcon = true,
    className = '',
    paddingBottom = false,
    useAnimate = true,
  } = props;
  const [openState, setOpenState] = useState(isOpened);

  useEffect(() => {
    if (isOpened && props.isLock) {
      setScrollTop(0);
    }
    setOpenState(isOpened);
  }, [isOpened]);

  const onClosingModal = () => {
    setOpenState(false);

    if (!useAnimate && onHide) {
      console.log('modal index onHIde  11111 trigger');
      onHide();
      return;
    }
    if (onHide) {
      setTimeout(() => {
        console.log('modal index timeout onHIde trigger');
        onHide();
      }, 350);
    }
  };

  return (
    <Modal
      {...props}
      onHide={onHide}
      isOpened={openState}
    >
      <div
        className={classnames(`modal-Wrapper ${className}`, {
          'large-bottom-padding': paddingBottom,
        })}
        onClick={e => {
          e.stopPropagation();
          onClick(e);
        }}
      >
        {
          closeIcon && (
            // <Icon
            //   name="close"
            //   className="close"
            //   onClick={() => {
            //     // onHide();
            //     onClosingModal();
            //   }}
            // />
            <div
              className="close"
              onClick={() => onClosingModal()}
            />
          )
        }
        {
          title && <div className="modal-title">{title}</div>
        }
        {props.children}
      </div>
    </Modal>
  );
};
